module.exports = __webpack_public_path__ + "static/img/call1.4bbcc31a.jpg";